import type { CompetitorSourceName } from '~/types/services/priceParrot';

export const competitorOffersQueryKeys = {
  all: ['competitor-offers'] as const,
  opportunities: (from: string, to: string) => [...competitorOffersQueryKeys.all, 'opportunities', from, to] as const,
  properties: () => [...competitorOffersQueryKeys.all, 'properties'] as const,
  property: (sourceName: CompetitorSourceName, externalPropertyId: string) =>
    [...competitorOffersQueryKeys.properties(), sourceName, externalPropertyId] as const,
  options: (sourceName: CompetitorSourceName, externalPropertyId: string) =>
    [...competitorOffersQueryKeys.property(sourceName, externalPropertyId), 'options'] as const,
  history: (sourceName: CompetitorSourceName, externalPropertyId: string) =>
    [...competitorOffersQueryKeys.property(sourceName, externalPropertyId), 'history'] as const,
  snapshot: (sourceName: CompetitorSourceName, externalPropertyId: string, collectionId: string) =>
    [...competitorOffersQueryKeys.property(sourceName, externalPropertyId), 'snapshot', collectionId] as const,
};
